import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { TracedMaterial } from '../traced-material'
import { BatchTracingConf } from '../../conf/batch-tracing-conf'
import { TracedMaterialBrowserComponent } from '../traced-material-browser/traced-material-browser.component'
import { AsyncPipe } from '@angular/common'

export interface ITracedMaterialBrowserDialogOptions {
  readonly tracedMaterials: TracedMaterial[]
}

@Component({
  selector: 'app-batch-tracing-conf-detail-dialog',
  templateUrl: './traced-material-browser-dialog.component.html',
  styleUrls: ['./traced-material-browser-dialog.component.scss'],
  imports: [TracedMaterialBrowserComponent, AsyncPipe],
})
export class TracedMaterialBrowserDialogComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly tracedMaterials$ = new BehaviorSubject<TracedMaterial[]>([])
  private dialogRef = inject<MatDialogRef<TracedMaterialBrowserDialogComponent>>(MatDialogRef)
  private data = inject<ITracedMaterialBrowserDialogOptions>(MAT_DIALOG_DATA)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.tracedMaterials$.next(this.data.tracedMaterials.map((tm) => this.copy(tm)))
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public close(): void {
    this.dialogRef.close()
  }

  /***************************************************************************
   *                                                                         *
   * Private methods                                                         *
   *                                                                         *
   **************************************************************************/

  private copy(material: TracedMaterial): TracedMaterial {
    return new TracedMaterial(
      material?.itemInfo,
      material?.workCenterId,
      material?.materialInfo,
      material?.spec,
      new BatchTracingConf(
        material?.conf?.specId,
        material?.conf?.serialNumber,
        material?.conf?.vendor
      )
    )
  }
}
